<div class="card card-info">
    <div class="card-header">
        <h4 class="card-title">Connected applications</h4>
    </div>
    <div class="card-body">
        <p>Applications this user has authorised to access Lumia using OAuth.</p>

        <div *adaptLoading="!authorizations">
            @if (errorMessage) {
                <div role="alert"
                     class="alert alert-danger mb-0">{{ errorMessage }}</div>
            } @else if (!person?.userId) {
                <p class="mb-0">This person does not have a linked user account.</p>
            } @else if (authorizations?.length === 0) {
                <p class="mb-0">This user has not authorised any applications.</p>
            } @else {
                <div class="d-flex flex-column gap-3">
                    @for (authorization of authorizations; track authorization.ClientId) {
                        <div class="d-flex flex-column flex-md-row align-items-md-center justify-content-between gap-2">
                            <div>
                                <div class="fw-semibold">{{ authorization.DisplayName }}</div>
                                @if (authorization.DisplayName !== authorization.ClientId) {
                                    <small class="text-muted">{{ authorization.ClientId }}</small>
                                }
                                <div class="small text-muted">Authorised {{ authorization.LastAuthorizedAt | date: "medium" }}</div>
                            </div>
                            <button class="btn btn-outline-danger align-self-start align-self-md-center"
                                    [adaptBlockingClick]="revokeAuthorization"
                                    [adaptBlockingClickParam]="authorization">Revoke access</button>
                        </div>
                    }
                </div>
            }
        </div>
    </div>
</div>
